export default __webpack_public_path__ + "static/media/GR5 2B-2C-1E-2EC.4fe03270.jpg";